import Col from "react-bootstrap/Col";
import FormGroup from "react-bootstrap/FormGroup";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import { FaTrash } from "react-icons/fa";

import { ReactSelectProps } from "../Selects/ReactSelect";
import { IdcsSelect } from "../Selects/IdcsSelect";
import { SkeletonWrapper } from "../SkeletonWrapper";

import "./styles.scss";

type IcdsSelectorProps = ReactSelectProps & {
	skeleton?: boolean;
	attendanceIdcs: MedicalSurgicalActIdc[];
	onChangeIdcType: (
		type: keyof MedicalSurgicalActIdcType,
		value: boolean,
		attendanceIdcId: number
	) => Promise<void>;
	onRemoveIdc: (attendanceIdcId: number) => Promise<void>;
};

export function IdcsSelector({
	attendanceIdcs,
	skeleton,
	onChangeIdcType,
	onRemoveIdc,
	...rest
}: IcdsSelectorProps) {
	return (
		<>
			<Col lg={8} md={12}>
				<FormGroup controlId="idc">
					<div className="mb-2">
						{skeleton ? (
							<SkeletonWrapper width="20%" />
						) : (
							<label className="fs-4 fw-bold">Buscar CID</label>
						)}
					</div>

					{skeleton ? (
						<SkeletonWrapper height={40} />
					) : (
						<IdcsSelect inputId="idc" placeholder="Buscar CID" {...rest} />
					)}
				</FormGroup>
			</Col>

			<div className="idc-list">
				{skeleton ? (
					<SkeletonWrapper height={40} count={3} />
				) : (
					attendanceIdcs.map((attendanceIdc, index) => (
						<div className="idc-item" key={`${attendanceIdc.idc.code}-${index}`}>
							<span className="code-idc">{attendanceIdc.idc.code}</span>

							<div className="description-idc">
								<span>{attendanceIdc.idc.description}</span>
							</div>

							<div className="types-idc">
								<span>Tipo:</span>

								<div className="check-list">
									<div className="line">
										<Form.Check
											id={`idc-${index}-diagnostic-hypothesis`}
											className="fs-7"
											checked={attendanceIdc.types.diagnosticHypothesis}
											label={
												<span>
													Hipótese <br />
													Diagnóstica
												</span>
											}
											onChange={(event) =>
												onChangeIdcType(
													"diagnosticHypothesis",
													event.target.checked,
													attendanceIdc.id
												)
											}
										/>

										<Form.Check
											id={`idc-${index}-diagnosis-confirmed`}
											className="fs-7"
											checked={attendanceIdc.types.diagnosisConfirmed}
											label={
												<span>
													Diagnóstico <br />
													confirmado
												</span>
											}
											onChange={(event) =>
												onChangeIdcType(
													"diagnosisConfirmed",
													event.target.checked,
													attendanceIdc.id
												)
											}
										/>
									</div>

									<div className="line">
										<Form.Check
											id={`idc-${index}-main-idc`}
											className="fs-7"
											checked={attendanceIdc.types.mainIdc}
											label="Principal"
											onChange={(event) =>
												onChangeIdcType(
													"mainIdc",
													event.target.checked,
													attendanceIdc.id
												)
											}
										/>

										<Form.Check
											id={`idc-${index}-chronic-disease`}
											className="fs-7"
											checked={attendanceIdc.types.chronicDisease}
											label={
												<span>
													Doença <br />
													crônica
												</span>
											}
											onChange={(event) =>
												onChangeIdcType(
													"chronicDisease",
													event.target.checked,
													attendanceIdc.id
												)
											}
										/>
									</div>
								</div>
							</div>

							<div className="action-idc">
								<Button
									variant="secondary"
									size="sm"
									className="h-40px"
									onClick={() => onRemoveIdc(attendanceIdc.id)}
								>
									<FaTrash />
								</Button>
							</div>
						</div>
					))
				)}
			</div>
		</>
	);
}
